// Per-user quick preferences surfaced in the top-bar Quick Settings panel.
// Stored in localStorage so they persist across sessions on this device.

export const LANDING_OPTIONS = [
  { id: 'dashboard', label: 'Dashboard', path: '/dashboard' },
  { id: 'defects', label: 'Defects', path: '/defects' },
  { id: 'work_orders', label: 'Work orders', path: '/work-orders' },
];

export const DENSITY_OPTIONS = [
  { id: 'compact', label: 'Compact' },
  { id: 'cosy', label: 'Standard' },
  { id: 'comfortable', label: 'Relaxed' },
];

const LANDING_KEY = 'guardian_landing_screen';
export const DENSITY_KEY = 'guardian_density';

export const getLandingScreen = () => {
  try { return localStorage.getItem(LANDING_KEY) || 'dashboard'; } catch { return 'dashboard'; }
};
export const setLandingScreen = (id) => {
  try { localStorage.setItem(LANDING_KEY, id); } catch { /* private mode */ }
};
export const getLandingPath = () => {
  const opt = LANDING_OPTIONS.find((o) => o.id === getLandingScreen());
  return opt ? opt.path : '/dashboard';
};

export const getGlobalDensity = () => {
  try { return localStorage.getItem(DENSITY_KEY) || 'cosy'; } catch { return 'cosy'; }
};
export const setGlobalDensity = (id) => {
  try { localStorage.setItem(DENSITY_KEY, id); } catch { /* private mode */ }
};
